export default __webpack_public_path__ + "static/media/Muli-Light.aac5722b.ttf";